import React from "react";
import Action from "../../components/Action";

/**
 * < 250 kWh reframe.
 *
 * We do not sell home batteries; instead we offer the visitor a share of a
 * larger community asset via reserve-block, or a facility visit. No RFP
 * button is rendered in this branch — this is the point of the guardrail.
 */
export default function UnderThreshold({ result }) {
  return (
    <div
      data-testid="audit-under-threshold-panel"
      style={{
        marginTop: 34,
        padding: "24px 26px",
        borderRadius: "var(--radius-lg)",
        background:
          "linear-gradient(180deg, rgba(31,170,89,0.10), rgba(31,170,89,0.02))",
        border: "1px solid rgba(31,170,89,0.35)",
      }}
    >
      <div
        className="gg-eyebrow"
        style={{ color: "var(--green-bright)", marginBottom: 8 }}
      >
        Below our project floor
      </div>
      <h3
        className="gg-h2"
        style={{ marginBottom: 12 }}
        data-testid="audit-under-threshold-title"
      >
        This site is smaller than our minimum viable Sovereign Block ({result.systemSizeKwh} kWh &lt; 250 kWh).
      </h3>
      <p
        style={{
          color: "var(--text-cloud)",
          fontSize: 16,
          lineHeight: 1.7,
          margin: 0,
        }}
        data-testid="audit-under-threshold-body"
      >
        But you don't need to buy your own battery. You can{" "}
        <Action
          route="reserve-block"
          sourceCell="audit"
          sourceState="under-250-redirect"
          source="audit"
        >
          co-own a share of a larger community asset
        </Action>{" "}
        near you — the same LFP chemistry, the same digital twin, the same
        returns, split fairly across everyone the asset powers. If you'd
        rather see how it feels first, you can also{" "}
        <Action
          route="book-tour"
          sourceCell="audit"
          sourceState="under-250-redirect"
          source="audit"
        >
          schedule a tour
        </Action>
        .
      </p>
    </div>
  );
}
